<template>
  <div class="block-result-type01 result-base">
    <div class="result-body" v-if="resultData">
      <span class="birthdate">{{userBirthdate}}</span>
      <h3 class="result-body--h3">{{baseTitle}}</h3>
      <div class="result-contents">
        <div class="subtitle" v-if="isSame">あなたの２つの暴露数は同じです</div>
        <div class="result-head" :class="{'is-same': isSame}">
          <div
            class="head-item"
            v-for="(item, idx) in resultList"
            :class="{[`head-${idx}`]:true, selected: selectedItem === idx}"
            :key="`h${idx}`"
            @click="onHeadItemClick(idx)"
          >
            <img :src="item.image" alt="">
            <span class="bakuro-num" v-if="!isSame" >暴露数{{item.unsei}}</span>
          </div>
        </div>

        <div class="result-panel-base">
          <swiper :options="swiperOptions" ref="resultpanel">
            <swiper-slide
              v-for="(item, idx) in resultList"
              :key="`p${idx}`"
            >
              <div class="sec-summery" v-if="!!item.name && item.name.length >0"><strong v-html="item.name"></strong></div>
              <div class="target-pros">
                <h3 class="target-title" v-if="hasProsAndCons">あなたの白密裏（長所）</h3>
                <p class="target-text" v-html="item.text1"></p>
              </div>
              <div class="target-cons" v-if="hasProsAndCons">
                <h3 class="target-title">あなたの黒密裏（短所）</h3>
                <p class="target-text" v-html="item.text2"></p>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <regist-birthdate
      :is-save="true"
      :csrf-token="csrfToken"
      v-else
    />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import RegistBirthdate from "./RegistBirthdate";

export default {
  name: 'BlockResultType01',
  components: {
    swiper,
    swiperSlide,
    RegistBirthdate,
  },
  props: {
    hasProsAndCons: {
      type: Boolean,
      default: true,
    },
    baseTitle: {
      type: String,
      required: true,
    },
    resultData: {
      //type: Object,
      type: [Object, Array],
      default: null,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      selectedItem: 0,
    }
  },
  computed: {
    isSame(){
      return this.resultData.result1.unsei === this.resultData.result2.unsei
      //return true
    },
    swiperOptions() {
      return {
        enabled: !this.isSame,
        noSwiping: !this.isSame,
        allowTouchMove: !this.isSame,
        on: {
          slideChange: this.onSlideChange
        }
      }
    },
    resultList(){
      if(this.isSame) return [this.resultData.result1, this.resultData.result1]
      return [this.resultData.result1, this.resultData.result2]
    },
    userBirthdate(){
      if(!!this.resultData && !!this.resultData.birthday){
        const year = +this.resultData.birthday.substring(0, 4);
        const month = +this.resultData.birthday.substring(4, 6);
        const day = +this.resultData.birthday.substring(6);
        return `${year}年${month}月${day}日`
      }
      return ''
    },
    panelSwiper(){
      return this.$refs.resultpanel.swiper
    },
  },
  methods: {
    onHeadItemClick(idx){
      if(!this.isSame && this.selectedItem !== idx) {
        this.panelSwiper.slideTo(idx, 300)
        this.selectedItem = idx
      }
    },
    onSlideChange(){
      this.selectedItem = this.panelSwiper.activeIndex
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables";
@import "../../../../../../sass/commons/styles/fonts";

.result-base {
  background: #f9f5ed;
  padding: 16px 20px 50px;

  .result-body {
    .birthdate {
      @extend .source-han-serif-bold;
      //font-family: $title-fontfamily;
      //font-weight: 600;
      //font-style: normal;
      display: block;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      color:var(--key-color);
    }
    .result-body--h3 {
      @extend .source-han-serif-bold;
      //font-family:$title-fontfamily;
      //font-style: normal;
      //font-weight: 600;
      font-size: 24px;
      line-height: 24px;
      text-align: center;
      //letter-spacing: 6px;
      color:var(--key-color);
      margin:0;
      margin-bottom: 24px;
    }
    .result-head {

      display: flex;
      margin-bottom: 22px;
      justify-content: space-between;
      .head-item {
        cursor: pointer;
        width: calc(50% - 13px);
        user-select: none;

        .bakuro-num{
          text-align: center;
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          line-height: 24px;
          display: block;
          padding-bottom: 12px;
          transition: all 300ms ease-out 0s;
          filter:alpha(0.2);
        }
        img {
          transition: all 300ms ease-out 0s;
          filter: brightness(0.4);
          border-radius: 10px;
          display: block;
          min-height: 140px;
          height: 140px;
          margin: auto;
          margin-bottom:12px;
        }
        &.selected {

          border-bottom: 2px solid var(--second);
          color:var(--second);
          img{
            filter: brightness(1);
          }
          .bakuro-num{
            filter:none;
          }

        }
      }
      &.is-same {
        .result-head{
          display: block;

        }
        .head-item {
          filter: none;
          cursor: default;
          img{
            filter:none;
            margin: auto;
            margin-bottom: 0;
          }
          &.selected {
            border: none;
          }
        }
      }

    }
    .subtitle{
      //font-family: 'Hiragino Kaku Gothic Pro';
      color: var(--second);
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      padding-bottom:12px;
      border-bottom: 2px solid var(--second);
      margin-bottom: 16px;
    }
    .result-contents{
      border: 1px solid var(--key-color);
      padding: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockResultType01.vue